// useFilterLogic.ts
import { useEffect, useState } from 'react'

export const useFilterLogic = (resultlist?: string) => {
  const [filters, setFilters] = useState({})
  const [workdayjobs, setWorkdayjobs] = useState([])
  const [visibleCount, setVisibleCount] = useState(20)
  const [tempSelections, setTempSelections] = useState({})
  const [openDropdown, setOpenDropdown] = useState(null)

  useEffect(() => {
    if (resultlist) {
      const fixedJson = resultlist.replace(/([{,])\s*(\w+)\s*:/g, '$1"$2":').replace(/'/g, '"')

      try {
        const parsed = JSON.parse(fixedJson)
        setWorkdayjobs(parsed)
      } catch (error) {
        console.error('Failed to parse workdayjobsdata:', error)
      }
    }
  }, [resultlist])

  const handleLoadMore = () => {
    setVisibleCount(prevCount => prevCount + 20)
  }

  const getOptions = (field: string): string[] => {
    return Array.from(new Set(workdayjobs.map(job => job[field]).filter(Boolean))).sort((a, b) =>
      a.localeCompare(b, undefined, { sensitivity: 'base' }),
    )
  }

  const toggleDropdown = (field: string) => {
    setOpenDropdown(openDropdown === field ? '' : field)
    setTempSelections(prev => ({ ...prev, [field]: filters[field] || [] }))
  }

  const toggleOption = (field: string, value: string) => {
    setTempSelections(prev => {
      const current = prev[field] || []
      const updated = current.includes(value) ? current.filter(v => v !== value) : [...current, value]

      return { ...prev, [field]: updated }
    })
  }

  const resetField = (field: string) => {
    setTempSelections(prev => ({ ...prev, [field]: [] }))
  }

  const applyFilter = (field: string) => {
    setFilters(prev => ({
      ...prev,
      [field]: tempSelections[field],
    }))
    setOpenDropdown(null)
  }

  const resetFilters = () => {
    setFilters({})
  }

  const removeFilter = (category: string, itemToRemove: string) => {
    setFilters(prevFilters => {
      const updatedCategoryItems = prevFilters[category].filter(item => item !== itemToRemove)

      const updatedFilters = {
        ...prevFilters,
        [category]: updatedCategoryItems,
      }

      if (updatedCategoryItems.length === 0) {
        delete updatedFilters[category]
      }

      return updatedFilters
    })
  }

  const filteredJobs = workdayjobs.filter(job =>
    Object.entries(filters).every(([key, value]) => !value || value?.length === 0 || value?.includes(job[key])),
  )

  const getAvailableOptions = (field: string): string[] => {
    return Array.from(new Set(filteredJobs.map(job => job[field]).filter(Boolean))).sort((a, b) =>
      a.localeCompare(b, undefined, { sensitivity: 'base' }),
    )
  }

  const visibleJobs = filteredJobs.slice(0, visibleCount)

  return {
    filters,
    setFilters,
    workdayjobs,
    filteredJobs,
    visibleJobs,
    visibleCount,
    tempSelections,
    openDropdown,
    handleLoadMore,
    getOptions,
    getAvailableOptions,
    toggleDropdown,
    toggleOption,
    resetField,
    applyFilter,
    resetFilters,
    removeFilter,
  }
}
